import { modifyState } from '~src/state';
import { toggleEditorSidebar, hideSidebarTab } from '~src/sidebarLegacy';
import { getActiveMagicFrameActive } from '~core/magicFrame';
import { handleMagicFrameBackgroundColors } from './handleMagicFrameSvgColors';

export const handleMagicFrameBackgroundSelection = async (url) => {
  modifyState('magicFrameSelectBackgroundPhotoActive', false);
  hideSidebarTab('manifesti');
  toggleEditorSidebar();
  const magicFrame = getActiveMagicFrameActive();
  await magicFrame.updateBackground(url);

  // Refresh background color pickers if it's an SVG
  handleMagicFrameBackgroundColors(magicFrame);

  window.canvas.renderAll();
};
